export const ACCESS_TOKEN_RECEIVED = 'ACCESS_TOKEN_RECEIVED' as const;

export const SHOW_LOADER_SPINNER = 'SHOW_LOADER_SPINNER' as const;
export const HIDE_LOADER_SPINNER = 'HIDE_LOADER_SPINNER' as const;

export const SHOW_MODAL = 'SHOW_MODAL' as const;
export const HIDE_MODAL = 'HIDE_MODAL' as const;
